export default {
  confirm: 'confirm account deletion',
  action: 'Delete your account',
};
